import Image from 'next/image'

function GraphDown() {
    return <Image src="/icons/graph-down.svg" alt="Graph Down" width={24} height={24} />
}

function GraphUp() {
    return <Image src="/icons/graph-up.svg" alt="Graph Up" width={24} height={24} />
}

export { GraphDown, GraphUp }
